import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { entertainmentPage, swimmingPage } from '../../utils';
import './EmptyEntertainmentCard.scss';

const EmptyEntertainmentCard = ({ type = entertainmentPage }) => (
  <Link className="empty-entertainment-card" to={type}>
    <div className="no-events">NO EVENTS SCHEDULE</div>
    <FontAwesomeIcon icon={faPlus} size="lg" />
    <div className="book">Book something</div>
  </Link>
);

EmptyEntertainmentCard.propTypes = {
  type: PropTypes.oneOf([entertainmentPage, swimmingPage]),
};

export default EmptyEntertainmentCard;
